module.exports = __webpack_public_path__ + "static/media/teachers.e16ffe51.jpg";